import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'ebazzari_feed_badge_dismissed_until'
const DISMISS_FOR_MS = 30 * 60 * 1000

export default class extends Controller {
  connect () {
    // Keep outside transformed ancestors so fixed bottom sticks to the viewport.
    if (this.element.parentElement !== document.body) {
      document.body.appendChild(this.element)
    }

    this.clearShowTimer()

    if (this.stillDismissed()) {
      this.hideNow()
      this.scheduleShowWhenReady()
      return
    }

    this.showNow()
  }

  disconnect () {
    this.clearShowTimer()
  }

  dismiss (event) {
    event.preventDefault()
    event.stopPropagation()

    const until = Date.now() + DISMISS_FOR_MS
    try {
      window.localStorage.setItem(STORAGE_KEY, String(until))
    } catch (_) {
      // Ignore storage errors (private mode, etc.)
    }

    this.element.classList.add('is-hiding')
    window.setTimeout(() => {
      this.element.classList.add('hidden')
      this.element.classList.remove('is-hiding')
    }, 220)

    this.scheduleShowWhenReady(until)
  }

  stillDismissed () {
    const until = this.dismissedUntil()
    if (!until) return false
    if (Date.now() >= until) {
      this.clearDismiss()
      return false
    }
    return true
  }

  dismissedUntil () {
    try {
      const raw = window.localStorage.getItem(STORAGE_KEY)
      if (!raw) return null
      const until = Number(raw)
      return Number.isFinite(until) ? until : null
    } catch (_) {
      return null
    }
  }

  clearDismiss () {
    try {
      window.localStorage.removeItem(STORAGE_KEY)
    } catch (_) {
      // Ignore storage errors
    }
  }

  scheduleShowWhenReady (until = this.dismissedUntil()) {
    this.clearShowTimer()
    if (!until) return

    const delay = Math.max(0, until - Date.now())
    this.showTimer = window.setTimeout(() => {
      this.clearDismiss()
      this.showNow()
    }, delay)
  }

  clearShowTimer () {
    if (this.showTimer) {
      window.clearTimeout(this.showTimer)
      this.showTimer = null
    }
  }

  showNow () {
    this.element.classList.remove('hidden', 'is-hiding')
  }

  hideNow () {
    this.element.classList.add('hidden')
    this.element.classList.remove('is-hiding')
  }
}
